"use client";

import { useEffect } from "react";

const API_BASE = (process.env.NEXT_PUBLIC_API_BASE ?? "/api").replace(/\/+$/, "");

export default function ClientWarm() {
  useEffect(() => {
    // ping a cheap health endpoint to wake the backend
    fetch(`${API_BASE}/progress/health`, { cache: "no-store" }).catch(() => {});
  }, []);

  return null;
}

